//Modal Cities Animation to switch between lists
import {delay} from "static/js/utility"

const FIRST_LVL_ITEMS = '.js-expandable-list';
const SECOND_LVL_MENUS = '.js-expanded-list';
const BACK_BTNS = '.js-back-btn';
const SHOW_CITY_PLACE = '.js-current-city';
const MODAL_WINDOW = '#citiesModal';
const SEARCHRESULTBOX = '#regionsresults';
const SERVER = $('[data-dev-env]').length > 0 ? 'https://test.yourroom.ru.loc' : '';
const MODAL_CONTENT_SELECTOR = '.modal-content';

$('[data-target="' + MODAL_WINDOW + '"]').click((e) => {
    let trigger = $(e.target).closest('[data-target]');
    if(trigger.length === 0) return;
    let modalId = trigger.data('target');
    let uri = trigger.data('uri');
    let uriParam = uri ? ('&uri=' + uri) : '';
    if(modalId){
        let modalContent = $(modalId).find(MODAL_CONTENT_SELECTOR);
        $(modalContent).empty();
        $(modalContent).load(SERVER + '/regions?task=showmodal' + uriParam, () => {
            $(modalId).modal();
        });
    }
});

//MENU ANIMATION LISTS
$(FIRST_LVL_ITEMS).click(function () {
    $(this).parent().find(SECOND_LVL_MENUS).addClass('city-modal__inner-list_expanded');
    $(window).scrollTop(0);
})

$(BACK_BTNS).click(function () {
    $(this).parents().find(SECOND_LVL_MENUS).removeClass('city-modal__inner-list_expanded');
})

//CURRENT CITY
jQuery(MODAL_WINDOW).on('click', 'li a.js-city, .js-back-btn a', function (e) {
    const href = jQuery(this).attr('href');
    if(href.search('showmodal') > -1){
        e.preventDefault();
        // $(SHOW_CITY_PLACE).text($(this).text());
        let modalContent = jQuery(this).closest(MODAL_CONTENT_SELECTOR);
        jQuery(modalContent).empty();
        jQuery(modalContent).load(href);
    }
});

// TOOLTIP PLUGIN DEFINITION
// =========================
$(function () {
    $('[data-toggle="tooltip"]').tooltip({
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-inner"></div></div>'
    });
})

$(MODAL_WINDOW).on('keyup', '.search-bar input[type="text"]', delay(function () {
    let q = $(this).val().trim();
    if(q === ''){
        $(SEARCHRESULTBOX).empty();
        $(SEARCHRESULTBOX).css({'visibility': 'hidden'});
        $(SEARCHRESULTBOX).removeClass('show');
        return;
    };
    let uri = $('[data-target="' + MODAL_WINDOW + '"]').data('uri');
    $.post(SERVER + '/regions?task=searchcity', {
        q,
        uri
    },function( data ) {
        $(SEARCHRESULTBOX).css({'visibility': 'visible'});
        $(SEARCHRESULTBOX).addClass('show');
        $(SEARCHRESULTBOX).html(data);
    });
}, 500));
